///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import { Component, ViewChild, ElementRef } from '@angular/core';
import { KbTextBoxBaseComponent } from './../text-box.base.component';

@Component({
    selector: 'kb-text-box',
    templateUrl: './text-box.component.html',
})
export class KbTextBoxComponent extends KbTextBoxBaseComponent {
    @ViewChild('input')
    public input: ElementRef;
}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/components/text-box/text-box.component.ts